import { render, staticRenderFns } from "./news-monitor@.vue?vue&type=template&id=457e1ea2&"
import script from "./news-monitor@.vue?vue&type=script&lang=ts&"
export * from "./news-monitor@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports